import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useRef } from "react";
import { useIntl } from "react-intl";

import { ImageCarousel } from "@/components/ImageCarousel/ImageCarousel";
import { TripCarouselCard } from "@/features/trips/components/TripCarouselCard";
import { tripsQueryOptions } from "@/features/trips/hooks/useTrips";
import { useInViewportOnce } from "@/hooks/useInViewportOnce";
import { rudderAnalytics, TripTrackingEvents } from "@/lib/rudderstack";

export function TripCarousel() {
  const intl = useIntl();
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);

  const { data: trips } = useQuery(tripsQueryOptions());
  const isEmpty = !trips || trips.length < 1;

  useInViewportOnce(containerRef, {
    callback: () => {
      rudderAnalytics.track(TripTrackingEvents.TRIP_CAROUSEL_VIEWED);
    },
  });

  if (isEmpty) return null;

  return (
    <div ref={containerRef}>
      <h6 className="mb-3.5 px-main text-xl font-bold text-text-title">
        {intl.formatMessage({ id: "trips.carouselTitle" })}
      </h6>

      <div className="px-main">
        <ImageCarousel
          items={trips}
          slides={{
            perView: "auto",
            origin: "auto",
            spacing: 12,
          }}
          getItemKey={(trip, index) => `${trip.id}-${index}`}
          className="overflow-visible!"
          slideClassName="flex w-65 min-w-65 flex-col items-start *:grow"
          renderItem={(trip) => {
            return (
              <TripCarouselCard
                trip={trip}
                onClick={() => {
                  rudderAnalytics.track(
                    TripTrackingEvents.TRIP_CAROUSEL_CLICKED,
                    {
                      trip_id: trip.id,
                      trip_name: trip.name,
                    },
                  );

                  navigate({
                    to: "/trips/$tripId",
                    params: { tripId: trip.id },
                  });
                }}
              />
            );
          }}
        />
      </div>
    </div>
  );
}
